import { Component } from '@angular/core';

interface NewsArticle {
  title: string;
  author?: string;
  publication: string;
  issue?: string; // format: DD MON YYYY
  url: string;
  lastAccessed: string;
  bluf: string;

  imageUrl?: string;
  imageAlt?: string;
}

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.css'],
})
export class NewsComponent {
  articles: NewsArticle[] = [    
    {
      title: "‘Signalgate’ Inspector General Report Wants Just One Change to Avoid a Repeat Debacle",
      author: "Lily Hay Newman",
      publication: "WIRED",
      issue: "December 4, 2025",
      url: "https://www.wired.com/story/signalgate-inspector-general-report-hegseth-change/",
      lastAccessed: "December 2025",
      imageUrl: "https://media.wired.com/photos/693097a9dfa33d6de97c4819/1:1/w_2240,c_limit/sec-hesgeth-signal-2241591545.jpg",
      imageAlt: "Secretary of Defense Pete Hegseth photographed during Signalgate reporting",
      bluf: "A US Inspector General report concludes that Secretary of Defense Pete Hegseth violated Department of Defense rules by using the consumer messaging app Signal on a personal device to share sensitive operational information, and recommends tightening classification and training procedures to prevent similar security failures."
    },
    {
      title: "WhatsApp 0-Day Vulnerability Exploited to Hack Mac and iOS Users",
      author: "Guru Baran",
      publication: "Cybersecurity News",
      issue: "August 29, 2025",
      url: "https://cybersecuritynews.com/whatsapp-0-day-vulnerability/",
      lastAccessed: "December 2025",
      imageUrl: "https://i1.wp.com/blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgNEtZhMuEXtyvIILQj-o_O_S_7h4-WOTQGG4e8UkWWPAiKBF64aYTzTdEUm8FwwkaqNDx66F6cjslEj-TpLpliG9y6Y0k9IHc83lT7khDhDC-7rcqg4MhUGk9S5afGS1r22c_sCZL0ZAdnFgc_2kwuVqIM9usjhR4l90dJiJHzMUvj4kSFm23lC8HtGuSA/s16000/WhatsApp%200-Day%20Vulnerability.webp",
      imageAlt: "WhatsApp zero-day vulnerability exploited on Apple devices",
      bluf: "A sophisticated spyware campaign exploited a WhatsApp zero-day vulnerability (CVE-2025-55177) in combination with an Apple ImageIO flaw (CVE-2025-43300) to compromise iOS and macOS devices, prompting WhatsApp and Apple to issue patches and warn targeted users to secure or reset affected systems."
    },
    {
      title: "WhatsApp Security Flaw Lets Experts Scrape 3.5 Billion User Numbers — Here’s What We Know, and How to Stay Safe",
      author: "Efosa Udinmwen",
      publication: "TechRadar",
      issue: "November 21, 2025",
      url: "https://www.techradar.com/pro/whatsapp-security-flaw-lets-experts-scrape-3-5-billion-user-numbers-heres-what-we-know-and-how-to-stay-safe",
      lastAccessed: "December 2025",
      imageUrl: "https://cdn.mos.cms.futurecdn.net/SmS7JrH5vq6kYg7Dea9UT6-650-80.jpg.webp",
      imageAlt: "WhatsApp security and data scraping illustration",
      bluf: "Researchers demonstrated that a flaw in WhatsApp’s contact-discovery system allowed large-scale enumeration and scraping of metadata from up to 3.5 billion accounts, exposing phone numbers and public profile information; WhatsApp has since implemented stronger rate limiting and emphasized that message content remained protected by end-to-end encryption."
    },
    {
      title: "Rome Pushes Meta to Allow Other AIs on WhatsApp",
      author: "Edited by Andrew Zinin",
      publication: "TechXplore",
      issue: "December 24, 2025",
      url: "https://techxplore.com/news/2025-12-rome-meta-ais-whatsapp.html",
      lastAccessed: "December 2025",
      imageUrl: "https://scx1.b-cdn.net/csz/news/800a/2025/blocking-rival-ai-chat.jpg",
      imageAlt: "Blocking rival AI chatbots from WhatsApp illustration",
      bluf: "Italian competition regulators ordered Meta to temporarily open WhatsApp to rival AI chatbots, warning that locking over three billion users into Meta AI could cause serious and irreparable harm to competition as EU authorities investigate potential antitrust violations."
    },
    {
      title: "U.S. House Bans WhatsApp on Official Devices Over Security and Data Protection Issues",
      author: "Ravie Lakshmanan",
      publication: "The Hacker News",
      issue: "June 24, 2025",
      url: "https://thehackernews.com/2025/06/us-house-bans-whatsapp-on-official.html",
      lastAccessed: "December 2025",
      imageUrl: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEi18SpnV87noYW_LVCF5D-pcBQlRaUz_Ag9uyEyj3G_e6MHKN8HIhLKWs2Jh6XuuBaDkcCxLdbzLi3fS5tzCj6ovApWTGccE0fNHx1BaAZvg3kBmZJT6Zm7yPxA0EUEOYmvUB6G8tqUheew-WLU3kBFWX_ACnt2AsRRU7t80rKagCuXZM2A62Lv9q8G8gDN/s790-rw-e365/whatsapp.jpg",
      imageAlt: "WhatsApp logo and mobile security illustration",
      bluf: "The U.S. House of Representatives banned WhatsApp on government-issued devices, citing transparency gaps in data protection and potential security risks, despite Meta’s assertion that the platform’s default end-to-end encryption offers strong user privacy."
    },
    {
      title: "APT28 Uses Signal Chat to Deploy BEARDSHELL Malware and COVENANT in Ukraine",
      author: "Ravie Lakshmanan",
      publication: "The Hacker News",
      issue: "June 24, 2025",
      url: "https://thehackernews.com/2025/06/apt28-uses-signal-chat-to-deploy.html",
      lastAccessed: "December 2025",
      imageUrl: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgSCsm-vkJhSB4r9f-J_7af9b7vQTRj_ZFsaLB0e-SCisXayIMdgeqxNJ9hjEbcxxnL3iHu1uyaTo387cKtN1YP3UZsa972bIhELjjrrbHeqvAthyphenhyphen6blAuiUHm4n1TIAivii-vLY6257RNfkG36zFPOao-bDNV_1eLO78V_zOvQ9TMdI49-rq8EialWG1mx/s790-rw-e365/SIGNAL.jpg",
      imageAlt: "Signal messaging app abused for malware delivery",
      bluf: "Ukraine’s CERT warned that Russia-linked APT28 used Signal chat messages to distribute malicious Word documents delivering the BEARDSHELL backdoor and the COVENANT framework, highlighting how trusted encrypted messaging platforms can be weaponized as initial access vectors in targeted cyber-espionage campaigns."
    }, 
    {
      title: "Trump Drops a Cybersecurity Bombshell With Biden-Era Policy Reversal",
      author: "Emil Sayegh",
      publication: "Forbes",
      issue: "June 7, 2025",
      url: "https://www.forbes.com/sites/emilsayegh/2025/06/07/trump-drops-a-cybersecurity-bombshell-with-biden-era-policy-reversal/",
      lastAccessed: "December 2025",
      imageUrl: "https://imageio.forbes.com/specials-images/imageserve/6843a7d8ab901384ceb86098/President-Donald-Trump-Shows-An-Executive-Order/0x0.jpg?width=960&dpr=1",
      imageAlt: "President Donald Trump signing a cybersecurity executive order",
      bluf: "President Trump signed a June 2025 cybersecurity executive order reversing key Biden-era policies, rolling back federal digital identity initiatives, eliminating mandatory software security attestations, narrowing AI’s role to risk management, and streamlining the post-quantum cryptography roadmap while explicitly naming foreign cyber adversaries."
    },
    {
      title: "UK Forces Apple to Create Backdoor Access to Spy Encrypted Data",
      author: "Cyber Security News",
      publication: "Cyber Security News (LinkedIn)",
      issue: "February 8, 2025",
      url: "https://www.linkedin.com/pulse/uk-forces-apple-create-backdoor-access-spy-encrypted-1a7oc",
      lastAccessed: "December 2025",
      imageUrl: "https://media.licdn.com/dms/image/v2/D5612AQHWv_oR62ebDg/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1739016472042?e=2147483647&v=beta&t=R0HUESbfBqqjS1DfE-KCyhYSbqgCjKknLa3pydYnWq0",
      imageAlt: "Apple encryption backdoor and UK surveillance debate illustration",
      bluf: "The UK government reportedly issued a secret order under the Investigatory Powers Act compelling Apple to create a backdoor granting blanket access to encrypted iCloud data, sparking global backlash over privacy, security risks, and the precedent such mandatory encryption weakening could set worldwide."
    }








    




  ];

  constructor() {
    this.sortArticlesByIssueDate();
  }

  private sortArticlesByIssueDate(): void {
    this.articles.sort((a, b) => {
      const dateA = this.parseIssueDate(a.issue);
      const dateB = this.parseIssueDate(b.issue);
      return dateB.getTime() - dateA.getTime(); // newest first
    });
  }

  private parseIssueDate(issue?: string): Date {
    if (!issue) {
      return new Date(0);
    }
    return new Date(issue);
  }
}
